import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { LfaContextAPIShape } from '../../../Context/LfaContext';
import Utils from '../../../Services/Utils';
import History from '../../../Services/History';

import { TextWidget } from '../../DynamicFormBuilderScreen/Widgets/Text';
import { NumberWidget } from '../../DynamicFormBuilderScreen/Widgets/Number';
import { CurrencyWidget } from '../../DynamicFormBuilderScreen/Widgets/Currency';
import { CheckboxWidget } from '../../DynamicFormBuilderScreen/Widgets/Checkbox';
import { RadioWidget } from '../../DynamicFormBuilderScreen/Widgets/Radio';
import { SelectWidget } from '../../DynamicFormBuilderScreen/Widgets/Select';
import { TextAreaWidget } from '../../DynamicFormBuilderScreen/Widgets/TextArea';
import { DateTimeWidget } from '../../DynamicFormBuilderScreen/Widgets/DateTime';
import { DateWidget } from '../../DynamicFormBuilderScreen/Widgets/Date';
import { TimeWidget } from '../../DynamicFormBuilderScreen/Widgets/Time';
import { FileWidget } from '../../DynamicFormBuilderScreen/Widgets/File';
import { PhotoWidget } from '../../DynamicFormBuilderScreen/Widgets/Photo';
import { MultiplePhotoWidget } from '../../DynamicFormBuilderScreen/Widgets/MultiplePhoto';
import { SignatureWidget } from '../../DynamicFormBuilderScreen/Widgets/Signature';
import { SliderRangeWidget } from '../../DynamicFormBuilderScreen/Widgets/SliderRange';
import { StarsWidget } from '../../DynamicFormBuilderScreen/Widgets/Stars';
import { UserNameWidget } from '../../DynamicFormBuilderScreen/Widgets/UserName';
import { PropertyNameWidget } from '../../DynamicFormBuilderScreen/Widgets/PropertyName';
import { PMSPropertyIdWidget } from '../../DynamicFormBuilderScreen/Widgets/PMSPropertyId';
import { TenantIdWidget } from '../../DynamicFormBuilderScreen/Widgets/TenantId';
import { PropertyAddressWidget } from '../../DynamicFormBuilderScreen/Widgets/PropertyAddress';
import { PropertyInfoWidget } from '../../DynamicFormBuilderScreen/Widgets/PropertyInfo';
import { UnitInfoWidget } from '../../DynamicFormBuilderScreen/Widgets/UnitInfo';
import { UnitBuildingWidget } from '../../DynamicFormBuilderScreen/Widgets/UnitBuilding';
import { UnitNumberWidget } from '../../DynamicFormBuilderScreen/Widgets/UnitNumber';
import { FileEmbeddedWidget } from '../../DynamicFormBuilderScreen/Widgets/FileEmbedded';
import { PageBreakWidget } from '../../DynamicFormBuilderScreen/Widgets/PageBreak';
import { FormDescriptionWidget } from '../../DynamicFormBuilderScreen/Widgets/FormDescription';
import ModalFieldNote from '../ModalFieldNote';
import ModalFieldPhoto from '../ModalFieldPhoto';
import { PhoneWidget } from '../../DynamicFormBuilderScreen/Widgets/Phone';
import { FileImageWidget } from '../../DynamicFormBuilderScreen/Widgets/FileImage';
import { Rating3ptWidget } from '../../DynamicFormBuilderScreen/Widgets/Rating3pt';

class DynamicFormsFieldComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalPhotoVisible: false,
      modalNoteVisible: false
    };
    this.addField = React.createRef()
  }

  componentDidMount() {
    History.singleton().register(
      'modalPhoto',
      () => {
        this.onPressedPhoto();
      },
      () => {
        this.onModalPhotoClose();
      }
    );
    History.singleton().register(
      'modalNote',
      () => {
        this.onPressedNote();
      },
      () => {
        this.onModalNoteClose();
      }
    );
  }

  componentWillUnmount() {
    History.singleton().unregister('modalPhoto');
    History.singleton().unregister('modalNote');
  }

  onPressedPhoto = () => {
    const { configuration } = this.props;
    if (configuration.disabled) return;
    History.singleton().show('modalPhoto');
    this.setState({ modalPhotoVisible: true });
  };

  onPressedNote = () => {
    const { configuration } = this.props;
    if (configuration.disabled) return;
    History.singleton().show('modalNote');
    this.setState({ modalNoteVisible: true });
  };

  onModalPhotoClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalPhotoVisible: false });
  };

  onModalNoteClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalNoteVisible: false });
  };

  getView = () => {
    const { descriptionAsIcon, showTriggerConditionMet, isCompact, configuration, data, error, errorTrigger, api, onPressedWorkOrder } = this.props;

    const commonProps = {
      label: configuration.label,
      value: data.value,
      onChange: (value) => api.onFieldValueChange(configuration.section, configuration.id, value),
      onChangeTrigger: (value) => api.onFieldTriggerChange(configuration.section, configuration.id, value),
      onError: (newError) => api.onFieldErrorChange(configuration.section, configuration.id, newError),
      onErrorTrigger: (newErrorTrigger) => api.onFieldErrorTriggerChange(configuration.section, configuration.id, newErrorTrigger),
      configuration,
      required: configuration.required,
      data,
      error,
      errorTrigger,
      api,
      isDisabled: true,
      field: configuration,
      descriptionAsIcon: descriptionAsIcon,
      showTriggerConditionMet: showTriggerConditionMet,
      isCompact: isCompact,
      handleClickAttachment: this.onPressedPhoto,
      handleClickNote: this.onPressedNote,
      handleClickWorkOrder: onPressedWorkOrder
    };

    switch (configuration.component) {
      case 'textInput':
        return <TextWidget {...commonProps} />;
      case 'phoneInput':
        return <PhoneWidget {...commonProps} />;
      case 'numberInput':
        return <NumberWidget {...commonProps} />;
      case 'currencyInput':
        return <CurrencyWidget {...commonProps} />;
      case 'checkbox':
      case 'checkboxJustifiedLeft':
        return <CheckboxWidget {...commonProps} options={configuration.options} />;
      case 'radio':
      case 'radioJustifiedLeft':
        return (
          <RadioWidget
            {...commonProps}
            options={configuration.options}
            onChange={(n, value) => api.onFieldValueChange(configuration.section, configuration.id, value)}
          />
        );
      case 'select':
        return <SelectWidget {...commonProps} onChange={({ value }) => api.onFieldValueChange(configuration.section, configuration.id, value)} />;
      case 'textArea':
        return <TextAreaWidget {...commonProps} />;
      case 'dateTimeInput':
        return <DateTimeWidget {...commonProps} />;
      case 'dateInput':
        return <DateWidget {...commonProps} />;
      case 'timeInput':
        return <TimeWidget {...commonProps} />;
      case 'fileImageInput':
        return <FileImageWidget {...commonProps} />;
      case 'fileInput':
        commonProps.field.image = Utils.isNull(configuration.image) ? false : configuration.image;
        commonProps.field.multiple = Utils.isNull(configuration.multiple) ? false : configuration.multiple;
        return <FileImageWidget {...commonProps} />;
      case 'imageInput':
        commonProps.field.image = Utils.isNull(configuration.image) ? true : configuration.image;
        commonProps.field.multiple = Utils.isNull(configuration.multiple) ? false : configuration.multiple;
        return <FileImageWidget {...commonProps} />;
      case 'imageMultipleInput':
        commonProps.field.image = Utils.isNull(configuration.image) ? true : configuration.image;
        commonProps.field.multiple = Utils.isNull(configuration.multiple) ? true : configuration.multiple;
        return <FileImageWidget {...commonProps} />;
      case 'signatureInput':
        return <SignatureWidget {...commonProps} />;
      case 'sliderRange':
        return <SliderRangeWidget {...commonProps} />;
      case 'starRate':
        return <StarsWidget {...commonProps} />;
      case 'userName':
        return <UserNameWidget {...commonProps} />;
      case 'propertyName':
        return <PropertyNameWidget {...commonProps} />;
      case 'pmsPropertyId':
        return <PMSPropertyIdWidget {...commonProps} />;
      case 'tenantId':
        return <TenantIdWidget {...commonProps} />;  
      case 'propertyAddress':
        return <PropertyAddressWidget {...commonProps} />;
      case 'propertyInfo':
        return <PropertyInfoWidget {...commonProps} />;
      case 'unitInfo':
        return <UnitInfoWidget {...commonProps} />;
      case 'unitBuilding':
        return <UnitBuildingWidget {...commonProps} />;
      case 'unitNumber':
        return <UnitNumberWidget {...commonProps} />;
      case 'fileEmbedded':
        return <FileEmbeddedWidget {...commonProps} />;
      case 'pageBreak':
        return <PageBreakWidget {...commonProps} />;
      case 'freeText':
        return <FormDescriptionWidget {...commonProps} />;
      case 'ratingScale3pt':
        return (
          <Rating3ptWidget
            {...commonProps}
            options={configuration.options}
            onChange={(n, value) => api.onFieldValueChange(configuration.section, configuration.id, value)}
          />
        );
      default:
        return <div />;
    }
  };

  isFieldVisible = () => {
    const { configuration, data } = this.props;

    if (data.visibility === false) {
      return false;
    }

    const visibleComponents = [
      'textInput',
      'phoneInput',
      'numberInput',
      'currencyInput',
      'checkbox',
      'checkboxJustifiedLeft',
      'radio',
      'radioJustifiedLeft',
      'select',
      'textArea',
      'dateTimeInput',
      'dateInput',
      'timeInput',
      'fileImageInput',
      'fileInput',
      'imageInput',
      'imageMultipleInput',
      'signatureInput',
      'sliderRange',
      'starRate',
      'userName',
      'unitNumber',
      'propertyName',
      'pmsPropertyId',
      'tenantId',
      'propertyAddress',
      'propertyInfo',
      'unitInfo',
      'unitBuilding',
      'fileEmbedded',
      'freeText',
      'pageBreak',
      'ratingScale3pt'
    ];
    if (visibleComponents.indexOf(configuration.component) === -1) {
      return false;
    }

    if (configuration.component === 'fileEmbedded') {
      return !Utils.isEmpty(configuration.embedded);
    }
    return true;
  };

  addField = (ref) => {
    this.props.onFieldAdded(this.props.configuration.id, ref);
  };

  getWidth = (childWidth,sectionColumns) => {
    let parentWidth = sectionColumns ? sectionColumns.value : 1;
    return `${(100 / parentWidth) * childWidth}%`;
  };


  render() {
    const { configuration, data, api, isCompact, sectionColumns } = this.props;
  
    if (this.isFieldVisible() === false) {
      return null;
    }
  
    const { modalPhotoVisible, modalNoteVisible } = this.state;
  
    const wrapperClasses = classNames('WrapperSection_Field', {
      WrapperSection_Field_Compact: Boolean(isCompact)
    });
  
    return (
      <>
        {configuration.force_line_break && <hr className='WrapperSection_Field_Next_Line_Hr_tag' />}
        <div
          ref={this.addField}
          style={{
            width: this.getWidth(configuration.display_width, sectionColumns),
          }}
          className={wrapperClasses}
        >
          {this.getView()}
          {modalPhotoVisible && <ModalFieldPhoto configuration={configuration} data={data} api={api} onClose={this.onModalPhotoClose} />}
          {modalNoteVisible && <ModalFieldNote configuration={configuration} data={data} api={api} onClose={this.onModalNoteClose} />}
        </div>
      </>
    );
  }
  
}

DynamicFormsFieldComponent.propTypes = {
  configuration: PropTypes.object.isRequired,
  descriptionAsIcon: PropTypes.bool,
  showTriggerConditionMet: PropTypes.bool,
  isCompact: PropTypes.bool,
  data: PropTypes.object.isRequired,
  error: PropTypes.string,
  errorTrigger: PropTypes.string,
  api: LfaContextAPIShape,
  onPressedWorkOrder: PropTypes.func.isRequired
};

export default DynamicFormsFieldComponent;
